import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import Popup from '../common/Popup';
import Loader from '../common/Loader';
import { ACTIONS } from '../../constants/strings';
import SequentialSurvey from '../SequentialSurvey';
import { SURVEYS_STATUS_TYPE } from '../../constants';
import ExpandableListItem from '../ExpandableListItem';
import getSpecification from '../../utils/survey/getSpecification';
import { convertPreVisitFormData } from '../Surveys/utils/preVisitForm';
import { enhance } from './enhance';

import styles from './index.styl';

const SequentialSurveyPopup = ({
  onClose,
  targetUserId,
  assignmentId,
  upcomingSurvey,
  formatMessage,
  clearUpcomingSurvey,
  isUpcomingSurveyRejected,
  sendUpcomingSurveyAnswers,
  sendUpcomingSurveyProceed,
  sendUpcomingSurveyCancelFilling,
}) => {
  const status = get(upcomingSurvey, 'status');
  const surveyAssignmentId = get(upcomingSurvey, 'assignmentId');
  const intervieweeName = get(upcomingSurvey, 'interviewee.displayableName');

  const [progress, setProgress] = useState(0);

  const {
    status: expirationStatus,
    description,
    heading,
    name,
  } = getSpecification(upcomingSurvey, formatMessage, false);

  const userAppointment = get(upcomingSurvey, 'userAppointment', null);
  const list = convertPreVisitFormData(formatMessage, userAppointment);

  const succeed = get(upcomingSurvey, 'succeed');

  useEffect(() => {
    if (isUpcomingSurveyRejected && onClose) onClose();
    if (assignmentId) {
      sendUpcomingSurveyProceed({
        targetUserId,
        assignmentId,
      });
    }
  }, [assignmentId, isUpcomingSurveyRejected]);

  const handleSubmit = ({ id, value }) => {
    const body = {
      assignmentId: surveyAssignmentId,
      status: SURVEYS_STATUS_TYPE.IN_PROGRESS,
      token: get(upcomingSurvey, 'meta.token'),
    };

    if (value) {
      sendUpcomingSurveyAnswers({
        ...body,
        answers: {
          question_id: id,
          value,
        },
      });
    }
  };

  const handleClose = () => {
    if (status === SURVEYS_STATUS_TYPE.STARTED) {
      sendUpcomingSurveyCancelFilling({
        targetUserId,
        assignmentId,
        token: get(upcomingSurvey, 'meta.token'),
      });
    }
    clearUpcomingSurvey();
    if (onClose) onClose();
  };

  return (
    <Popup
      strictClose
      width="medium"
      overflowVisible
      onClose={handleClose}
      dialogClassName={styles.popup}
      opened={Boolean(surveyAssignmentId)}
      paperClassName={styles.paperClassName}
      title={formatMessage(ACTIONS.survey.upcomingHeading, {
        user: intervieweeName,
      })}
    >
      <Choose>
        <When condition={succeed && surveyAssignmentId}>
          <ExpandableListItem
            locked
            key={assignmentId}
            progress={progress}
            data-id={assignmentId}
            header={{
              expirationStatus,
              icon: 'up-surveys',
              subtitle: heading,
              title: name,
              description,
              list,
            }}
          >
            <SequentialSurvey
              survey={upcomingSurvey}
              onSubmit={handleSubmit}
              setProgress={setProgress}
            />
          </ExpandableListItem>
        </When>
        <Otherwise>
          <Loader />
        </Otherwise>
      </Choose>
    </Popup>
  );
};

SequentialSurveyPopup.propTypes = {
  onClose: PropTypes.func,
  assignmentId: PropTypes.number,
  upcomingSurvey: PropTypes.object,
  formatMessage: PropTypes.func.isRequired,
  isUpcomingSurveyRejected: PropTypes.bool,
  targetUserId: PropTypes.number.isRequired,
  clearUpcomingSurvey: PropTypes.func.isRequired,
  sendUpcomingSurveyProceed: PropTypes.func.isRequired,
  sendUpcomingSurveyAnswers: PropTypes.func.isRequired,
  sendUpcomingSurveyCancelFilling: PropTypes.func.isRequired,
};

export default enhance(SequentialSurveyPopup);



// WEBPACK FOOTER //
// ./src/components/SequentialSurveyPopup/index.jsx